enum UniqueDomIdentifiers {
  billingView = 'billing-view',
  preferredStoreView = 'preferred-store-view',
  preferredStoreViewContactInfo = 'preferred-store-view-contact-info',
  preferredStoreViewWhoPickup = 'preferred-store-view-who-pickup',
  giftWrap = 'giftwrap',
}

export default UniqueDomIdentifiers;
